import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const StyledLink = styled(Link)<{ isDisabled?: boolean }>`
  word-break: break-word;

  div {
    text-decoration: underline;
    color: ${(p) => p.theme.colors[p.isDisabled ? 'defaultText' : 'blue1']};
  }
`

export const StyledLinkFlex = styled(StyledLink)<{ isDisabled?: boolean }>`
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;

  a,
  div {
    text-decoration: none;
  }

  & {
    text-decoration: none;
    color: ${(p) => p.theme.colors[p.isDisabled ? 'defaultText' : 'blue1']};

    :hover {
      text-decoration: underline;
    }

    :visited,
    :visited div {
      color: ${(p) => p.theme.colors.purple2};
    }
  }
`
